import { Component, OnInit } from '@angular/core';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss']
})
export class ProcessComponent implements OnInit {
  
  public ourCompanyName: string=this.platformInviewService.getOurCompanyName();
  
  constructor(
    private platformInviewService: PlatformInviewService
  ) { }

  ngOnInit(): void {
  }

}
